export const messages = {
  buttonBack: {
    id: "button-back.text",
    defaultMessage: "Back",
  },
};
